import { useMutation, useQuery } from '@apollo/client/react';
import { Box, Button, Center, Heading, HStack, Link, Spinner, Table, Text } from '@chakra-ui/react';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { gql } from '@src/lib/gql';
import { scoBackendUrl } from '@src/lib/startups-url';
import React, { useCallback } from 'react';
import { LuSquareArrowUpRight, LuPlus } from 'react-icons/lu';
export const LaunchrockAccountsBlock = (props: {}) => {
  const query = useQuery(gql`
    query {
      viewer {
        id
        currentUser {
          id
          linkedLaunchrockAccounts {
            id
            externalUserId
            email
            companies {
              externalId
              externalType
              name
              signedUrl
            }
            signedAppUrl
            signedCreateCompanyUrl
          }
        }
      }
    }
  `);
  const [createLinkedAccount, createLinkedAccountMutation] = useMutation(gql`
    mutation ($input: CreateLinkedAccountInput!) {
      createLinkedAccount(input: $input) {
        linkedAccount {
          id
        }
      }
    }
  `);
  const handleCreateAccount = useCallback(async () => {
    try {
      await createLinkedAccount({
        variables: {
          input: {
            app: 'launchrock'
          }
        }
      });
      await query.refetch();
    } catch (err) {
      alert('An error occurred.');
    }
  }, []);
  const accounts = query.data?.viewer?.currentUser?.linkedLaunchrockAccounts || [];
  return <Box bgColor={'colorPalette.container'} border={'1px solid {colors.colorPalette.border/50}'} borderRadius={'md'} padding={6} width={'full'}>
      <HStack align={'center'} justify={'space-between'}>
        <Box>
          <Heading>Launchrock.com</Heading>
          <Text>Acquire your startup's first customers.</Text>
        </Box>
        <Box>
          <PaywalledAction contentPermission={'canActivateLaunchrock'}>
            <>
              {accounts.length == 0 && <Box>
                  <Button disabled={createLinkedAccountMutation.loading || query.loading} loading={createLinkedAccountMutation.loading || query.loading} onClick={ev => {
                ev.preventDefault();
                handleCreateAccount();
              }}>
                    Redeem Your Free Account
                  </Button>
                </Box>}
            </>
          </PaywalledAction>
        </Box>
      </HStack>
      <PaywalledAction contentPermission={'canActivateLaunchrock'} variant={'blank'}>
        <>
          {query.loading && <Center padding={'1em'}>
              <Spinner />
            </Center>}

          {accounts.length > 0 && <Box paddingTop={'1em'}>
              {accounts.map(account => <Box key={account.id} bgColor={'colorPalette.bg'} paddingTop={'0.5em'}>
                  <Table.Root>
                    <Table.Header>
                      <Table.Row>
                        <Table.ColumnHeader colSpan={2}>
                          {'Account: '}
                          {account.email}
                        </Table.ColumnHeader>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {account.companies.length === 0 && <Table.Row>
                          <Table.Cell colSpan={2} textAlign={'center'}>
                            You don't have any plans yet.
                          </Table.Cell>
                        </Table.Row>}
                      {account.companies.map((company, idx) => <Table.Row key={idx}>
                          <Table.Cell width={'full'}>
                            {'Site: '}
                            <strong>{company.name || `Untitled ${idx}`}</strong>
                          </Table.Cell>
                          <Table.Cell>
                            <Button asChild size={'sm'}>
                              <Link href={scoBackendUrl(company.signedUrl)} target={'_blank'}>
                                Manage Site
                                <LuSquareArrowUpRight />
                              </Link>
                            </Button>
                          </Table.Cell>
                        </Table.Row>)}
                      <Table.Row>
                        <Table.Cell colSpan={2} padding={'1.5em'} textAlign={'center'}>
                          <Button asChild size={'sm'} variant={'outline'}>
                            <Link href={scoBackendUrl(account.signedCreateCompanyUrl)} target={'_blank'}>
                              <LuPlus />
                              Create a New Site on Launchrock
                              <LuSquareArrowUpRight />
                            </Link>
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table.Root>
                </Box>)}
            </Box>}
        </>
      </PaywalledAction>
    </Box>;
};